import * as React from 'react';
import { Navigation, Cart} from '@bepure/tarkin';
import { CURRENCY }  from '@bepure/tarkin/dist/utils/cart';

interface Props {
    navConfig: {
        thrawnURL: string;
        cartURL: string;
        kenobiBlogURL: string;
        BASE_API_URL: string;
    };
    loggedIn: boolean;
    showBanner: boolean;
}

interface State {
    bannertext: string;
}
class PreLaunchNav extends React.PureComponent<Props,State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            bannertext: "Free shipping on all NZ orders & AU orders over $89"
        }
    }

    componentDidMount () {
        this.getBannerText().then((response)=>{
            this.setState({'bannertext':response});
        })
    }

    public render() {
        const thrawnPath = {
            REGISTER_TEST_KIT: '/register-test-kit',
            TEST_KIT_SIGN_IN: '/go',
            QUIZZES: '/quizzes',
            MY_ACCOUNT: '/my-account',
            LOGIN: '/login',
            SUBSCRIPTIONS: '/my-subscriptions',
            ACCOUNT_SETTINGS: '/account-info',
        };

        const authenticationAction = this.props.loggedIn ? {
            text: '',
            icon: 'person_outline',
            auth: true,
            navGroup: [
                {
                    text: `Welcome!`
                },
                {
                    text: 'My test kits',
                    iconSVG: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Menu/CustomerPortal_Results_30x30.svg',
                    iconRHS: true,
                    onClick: this.handleRedirectOnClick(thrawnPath.MY_ACCOUNT, this.props.navConfig.thrawnURL),
                },
                {
                    text: 'Manage subscriptions',
                    iconSVG: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Menu/CustomerPortal_Subscriptios_30x30.svg',
                    iconRHS: true,
                    onClick: this.handleRedirectOnClick(thrawnPath.SUBSCRIPTIONS, this.props.navConfig.thrawnURL),
                },
                {
                    text: 'Change password',
                    iconSVG: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Menu/CustomerPortal_Password_30x30.svg',
                    iconRHS: true,
                    onClick: this.handleRedirectOnClick(thrawnPath.ACCOUNT_SETTINGS, this.props.navConfig.thrawnURL),
                },
                {
                    text: 'Register my test',
                    iconSVG: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Menu/CustomerPortal_RegisterTest_30x30.svg',
                    iconRHS: true,
                    onClick: this.handleRedirectOnClick(thrawnPath.REGISTER_TEST_KIT, this.props.navConfig.thrawnURL),
                },
                {
                    text: 'Logout',
                    iconSVG: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Menu/CustomerPortal_Logout_30x30.svg',
                    iconRHS: true,
                    onClick: this.logout,
                }
            ],
        } : {
                text: 'Sign In',
                icon: 'person_outline',
                onClick: this.handleRedirectOnClick(thrawnPath.LOGIN, this.props.navConfig.thrawnURL),
            };

    

        return (
            <Navigation
                loggedIn={this.props.loggedIn}
                name={''}
                logo={'https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Eve_EveLogo_104x35.svg'}
                onHomeClick={this.onHomeClick}
                hamburgerVisible={true}
                navBannerText={this.props.showBanner ? this.state.bannertext : undefined}
                cartLink={this.props.navConfig.cartURL}
                onCurrencyChange={this.handleCurrencyChange}
                BASE_API_URL={this.props.navConfig.BASE_API_URL}
                // mainMenuCallToAction={mainMenuCallToAction}
                mainMenuLinks={[
                    {
                        text: 'Friends with benefits',
                        link: '/friends-benefits/'
                    },
                    {
                        text: 'About Eve',
                        navGroup: [
                            {
                                text: 'Eve\'s Story',
                                link: '/about',
                            },
                            {
                                text: 'FAQs',
                                link: '/faqs',
                            }, {
                                text: 'Contact Us',
                                link: '/contact-us',
                            },
                        ],
                    },
                    {
                        text: 'Blog',
                        onClick: this.handleRedirectOnClick('/blog', this.props.navConfig.kenobiBlogURL),
                    },
                    {
                        text: 'Shop Now',
                        outline: true,
                        link: '/store/?ref=topnav ',
                    }
                    
                ]}
                mainMenuLinksSecondary={
                    [
                        authenticationAction
                    ]
                }
                navItems={[
                    {
                        text: 'Friends with benefits',
                        link: '/friends-benefits/'
                    },
                    {
                        text: 'Science',
                        link: 'https://engage.evewellness.com/blog/hello-hormones-the-science-behind-eve-testing'
                    },
                    {
                        text: 'About Eve',
                        navGroup: [
                            {
                                text: 'Eve\'s Story',
                                link: '/about',
                            }, {
                                text: 'FAQs',
                                link: '/faqs',
                            }, {
                                text: 'Contact Us',
                                link: '/contact-us',
                            },
                        ],
                    },
                    {
                        text: 'Blog',
                        onClick: this.handleRedirectOnClick('/blog', this.props.navConfig.kenobiBlogURL),
                    },
                    {
                        text: 'Shop Now',
                        link: '/store/?ref=topnav',
                    }
                ]}
            />
        );
    }

    private onHomeClick = () => {
        window.location.assign('/');
    }

    private handleRedirectOnClick = (path: string, baseURL: string) => {
        console.log(baseURL + path)
        return ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (baseURL) {
                window.location.href = baseURL + path;
            }
        });
    }

    private handleCurrencyChange = (value: string) => {
        const cart = Cart.getInstance();
        const currency: CURRENCY = (value as CURRENCY);
        localStorage.setItem('currency', currency);
        cart.updateCartCurrency(currency).then(() => window.location.reload());
    }

    private logout = () => {
        if(localStorage['state']) {
            localStorage.removeItem('state')
            window.location.reload();
        }
    }

    private getBannerText = async () => {
        const response = await fetch(`${this.props.navConfig.BASE_API_URL}/v1/service/bigcommerce/banner`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        try {
            const content = await response.json();
            return Promise.resolve(content.bannertext);
        } catch (error) {
            throw Promise.reject({
                error: error.message,
            });
        }
    }
}

export default PreLaunchNav;
